import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Resident } from '@models/account/resident.model';
import moment from 'moment';

@Component({
  selector: 'app-engagement-plan-modal',
  templateUrl: './engagement-plan-modal.component.html',
  styles: [],
})
export class EngagementPlanModalComponent {
  api = inject(CommonVerbsApiService);
  route = inject(ActivatedRoute);
  resident!: Resident;

  modal = inject(NgbActiveModal);
  month = moment().format('MMMM');

  download(type: string) {
    this.api
      .download<Blob>(`users/${this.resident.id}/engagement-plan`, { type })
      .subscribe({
        next: response => {
          const blob = new Blob([response], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Engagement_Plan_${this.month}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        error: err => {
          console.error('Error al descargar el PDF:', err);
        },
      });
  }
}
